Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the media step
	 */
	mediaSetup() {
		const scope = this;

		if (! scope.syndicated) {
			scope.initImages();
			scope.initVideos();
			scope.initEmbeds();
			scope.initLinks();
			scope.initAttachments();
		}
	},

	/**
	 * Initialize images
	 */
	initImages() {
		const scope = this;
		const $input = $$('postImagesInput');
		const $upload = $$('postImagesDrop');
		const hoverClass = '-is-hovering';

		scope.initReorder('images');

		$input.on('change', e => {
			scope.processImages(e.target.files);
		}, {
			namespace: 'post'
		});

		$upload.on({
			mousedown: () => {
				$input[0].click();
			},
			drop: e => {
				e.preventDefault();

				scope.processImages(e.dataTransfer.files);

				$upload[0].classList.remove(hoverClass);
			},
			dragover: e => {
				e.preventDefault();

				$upload[0].classList.add(hoverClass);
			},
			dragleave: e => {
				if ($upload[0].contains(e.relatedTarget)) {
					return;
				}

				$upload[0].classList.remove(hoverClass);
			}
		}, {
			namespace: 'post'
		});

		$.events.on('$deleteImage', 'click', (e, el) => {
			$.app.post.$drop('data.images.' + $(el).parent().index());
		}, {
			delegate: scope.$form,
			namespace: 'post'
		});

		$.events.on('$postImagesCaption', 'change', (e, el) => {
			if (! scope.validateCaption(el.value)) {
				el.value = '';
			}
		}, {
			delegate: '$postImages',
			namespace: 'post'
		});
	},

	/**
	 * Process images
	 *
	 * @param {FileList} files
	 */
	processImages(files) {
		const scope = this;
		const start = $.app.post.$get('data.images', []).length;

		Array.from(files)
			.sort((a, b) => a.name.localeCompare(b.name, undefined, {
				numeric: true
			}))
			.forEach((file, index) => {
				scope.processImage(file, start + index);
			});
	},

	/**
	 * Process image
	 *
	 * @param {File} file
	 * @param {Number} index
	 */
	processImage(file, index) {
		const allowed = [
			'image/avif',
			'image/gif',
			'image/jpeg',
			'image/png',
			'image/webp'
		];

		if (! allowed.includes(file.type)) {
			LS.util.warn('Only image files are allowed', {
				type: file.type
			});

			return;
		}

		const img = new Image();
		const uid = LS.util.uid();

		img.draggable = false;

		img.addEventListener('load', () => {
			let valid = true;

			if (img.width < 580 || img.height < 435) {
				valid = false;

				LS.util.warn('Images must be at least 580x435px', true);
			}

			if (valid) {
				$.app.post.$set(`data.images.${index}`, {
					file: file,
					key: uid,
					type: file.type
				});

				$('.js-image', `[data-uid="img-${uid}"]`).replaceWith(img);
			}

			URL.revokeObjectURL(img.src);
		}, {
			once: true
		});

		img.src = URL.createObjectURL(file);
	},

	/**
	 * Validate image caption
	 *
	 * @param {String} caption
	 * @returns {Boolean}
	 */
	validateCaption(caption) {
		if (! caption) {
			return true;
		}

		if (! caption.includes(' ')) {
			LS.util.warn('Single-word captions are not allowed');

			return false;
		}

		const generic = [
			'(3d )?((aerial|drone|satellite) )?((area|land|location|lot|map|parcel|property|site|street) )?(image|location|map|outline|photo|tour|view)( ?\d+)?'
		];

		if (new RegExp('^(' + generic.join('|') + ')$', 'i').test(caption)) {
			LS.util.warn('Only meaningful captions are allowed');

			return false;
		}

		return true;
	},

	/**
	 * Initialize videos
	 */
	initVideos() {
		const scope = this;
		const key = 'data.videos';

		scope.initReorder('videos');

		$.events.on({
			'$addVideo': {
				click: () => {
					$.app.post.$push(key, {
						caption: '',
						source: '',
						source_url: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteVideo': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			},
			'$sourceVideo': {
				change: (e, el) => {
					$.app.post.$merge(key + '.' + $(el).closest('.form-list__row').index(), {
						source: el.value
					});
				}
			}
		}, {
			delegate: scope.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize embeds
	 */
	initEmbeds() {
		const key = 'data.embeds';

		$.events.on({
			'$addEmbed': {
				click: () => {
					$.app.post.$push(key, {
						source: '',
						source_url: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteEmbed': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			},
			'$sourceEmbed': {
				change: (e, el) => {
					$.app.post.$merge(key + '.' + $(el).closest('.form-list__row').index(), {
						source: el.value
					});
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize links
	 */
	initLinks() {
		const key = 'data.links';

		$.events.on({
			'$addLink': {
				click: () => {
					$.app.post.$push(key, {
						url: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteLink': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize attachments
	 */
	initAttachments() {
		const scope = this;
		const $input = $$('postAttachmentsInput');
		const $upload = $$('postAttachmentsDrop');
		const hoverClass = '-is-hovering';

		scope.initReorder('attachments');

		$input.on('change', e => {
			scope.processAttachments(e.target.files);
		}, {
			namespace: 'post'
		});

		$upload.on({
			mousedown: () => {
				$input[0].click();
			},
			drop: e => {
				e.preventDefault();

				scope.processAttachments(e.dataTransfer.files);

				$upload[0].classList.remove(hoverClass);
			},
			dragover: e => {
				e.preventDefault();

				$upload[0].classList.add(hoverClass);
			},
			dragleave: e => {
				if ($upload[0].contains(e.relatedTarget)) {
					return;
				}

				$upload[0].classList.remove(hoverClass);
			}
		}, {
			namespace: 'post'
		});

		$.events.on('$deleteAttachment', 'click', (e, el) => {
			$.app.post.$drop('data.attachments.' + $(el).parent().index());
		}, {
			delegate: scope.$form,
			namespace: 'post'
		});
	},

	/**
	 * Process attachments
	 *
	 * @param {FileList} files
	 */
	processAttachments(files) {
		const scope = this;

		Array.from(files)
			.sort((a, b) => a.name.localeCompare(b.name, undefined, {
				numeric: true
			}))
			.forEach(file => {
				scope.processAttachment(file);
			});
	},

	/**
	 * Process attachment
	 *
	 * @param {File} file
	 */
	processAttachment(file) {
		const allowed = {
			'application/pdf': 'PDF',
			'application/vnd.ms-excel': 'XLS',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
			'image/gif': 'GIF',
			'image/jpeg': 'JPEG',
			'image/png': 'PNG',
			'image/tiff': 'TIFF',
			'image/webp': 'WebP'
		};

		if (! allowed[file.type]) {
			LS.util.warn('Only diagrams and documents are allowed', {
				type: file.type
			});

			return;
		}

		$.app.post.$push('data.attachments', {
			file: file,
			key: LS.util.uid(),
			type: file.type,
			caption: LS.util.capitalize(
				file.name.replace(/\.[^/.]+$/, '')
					.replace(/[-_ .]+/, ' ')
			),
			format: allowed[file.type],
			size: file.size
		});
	},

	/**
	 * Initialize reordering
	 *
	 * @param {String} key
	 */
	initReorder(key) {
		const selector = '$post' + LS.util.capitalize(key) + 'Row';

		let cancel;
		let children;
		let over;
		let dragging;
		let start;
		let source;
		let target;

		$.events.on(selector, {
			mousedown: e => {
				cancel = e.target.nodeName === 'INPUT';
			},
			dragstart: (e, el) => {
				if (cancel) {
					e.preventDefault();

					return;
				}

				dragging = el;

				children = $(selector).toArray();

				start = children.indexOf(dragging);

				el.classList.add('-is-dragging');
			},
			dragend: (e, el) => {
				if (! dragging) {
					return;
				}

				dragging = null;

				const rows = $.app.post.$get('data.' + key);

				el.classList.remove('-is-dragging');

				rows.splice(target, 0, rows.splice(start, 1)[0]);

				$.app.post.$set('data.' + key, rows);
			},
			dragover: (e, el) => {
				e.preventDefault();

				if (! dragging) {
					return;
				}

				source = children.indexOf(dragging);
				target = children.indexOf(el);

				if (target === source) {
					return;
				}

				if (target > source) {
					el.after(dragging);
				} else {
					el.before(dragging);
				}

				children.splice(source, 1);
				children.splice(target, 0, dragging);
			},
			dragenter: (e, el) => {
				over = el;
			},
			dragleave: () => {
				over = null;
			}
		}, {
			delegate: '$post' + LS.util.capitalize(key),
			namespace: 'post'
		});
	},

	/**
	 * Validate media step
	 *
	 * @returns {Boolean}
	 */
	mediaValidate() {
		const scope = this;

		let valid = true;

		scope.mediaDrop();

		$.app.post.$get('data.images', []).forEach(image => {
			if (! scope.validateCaption(image.caption)) {
				valid = false;
			}
		});

		$.app.post.$get('data.videos', []).forEach(video => {
			if (! video.source) {
				return;
			}

			if (video.source === 'youtube') {
				if (! video.source_url.includes('youtu')) {
					LS.util.warn('Update or remove invalid YouTube video', {
						url: video.source_url
					});

					valid = false;
				}
			} else if (! video.source_url.includes('vimeo')) {
				LS.util.warn('Update or remove invalid Vimeo video', {
					url: video.source_url
				});

				valid = false;
			}
		});

		if (! valid) {
			return false;
		}

		return scope.validateStep();
	},

	/**
	 * Remove empty media rows
	 */
	mediaDrop() {
		this.drop([
			'embeds',
			'links',
			'videos'
		]);
	}
});